import React, { createContext, useState, useCallback, useRef } from 'react';
import {
  ProviderCadastroProducaoProps,
  CadastroProducaoContextData,
  Producao,
} from '../types';
import { useForm } from 'react-hook-form';
import { MasterDetailProps } from '~/utils/masterDetail';

export const CadastroProducaoContext = createContext(
  {} as CadastroProducaoContextData,
);
const masterDetailDefault = [
  {
    obj_name: 'produtos',
    pk_fields: ['cod_seq_produto_producao'],
    itens: {
      insert: [],
      update: [],
      delete: [],
    },
  },
];

export const CadastroProducaoProvider: React.FC<
  ProviderCadastroProducaoProps
> = ({ children }) => {
  const [formData, setFormDataState] = useState<any>(null);
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [updateItem, setUpdateItem] = useState<boolean>(false);
  const [showSearch, setShowSearch] = useState<boolean>(true);
  const [produtoIdUpdate, setProdutoIdUpdate] = useState<number | undefined>(
    undefined,
  );
  const [masterDetail, setMasterDetail] =
    useState<MasterDetailProps[]>(masterDetailDefault);
  const [produtoAtual, setProdutoAtual] = useState<any>(null);

  const [produtosRows, setProdutosRows] = useState<any[]>([]);

  const [qtdRendUnit, setQtdRendUnit] = useState<number>(0);
  const [custoSemImposto, setCustoSemImposto] = useState<number>(0);
  const [valCustoReceita, setValCustoReceita] = useState<number>(0);
  const [qtdTotReceita, setQtdTotReceita] = useState<number>(0);
  const [qtdTotProducao, setQtdTotProducao] = useState<number>(0);
  const [qtdRendeKG, setQtdRendeKg] = useState<number>(0);
  const [valCustoProducao, setValCustoProducao] = useState<number>(0);
  const [valCustoFinal, setValCustoFinal] = useState<number>(0);

  const containerRef = useRef<HTMLElement | null>(null);

  const {
    register,
    reset,
    setValue,
    handleSubmit,
    watch,
    clearErrors,
    getValues,
    control,
    setFocus,
    setError,
    formState,
  } = useForm({
    reValidateMode: 'onSubmit',
  });

  const setFormData = useCallback(
    (value: Producao) => setFormDataState(value),
    [setFormDataState],
  );

  const setProdutoAtualReset = useCallback(
    () => setProdutoAtual(null),
    [setProdutoAtual],
  );

  return (
    <CadastroProducaoContext.Provider
      value={{
        containerRef,
        isUpdate,
        setIsUpdate,
        showSearch,
        setShowSearch,
        setProdutoAtualReset,
        setFormData,
        formData,
        updateItem,
        setUpdateItem,
        produtoIdUpdate,
        setProdutoIdUpdate,
        produtoAtual,
        setProdutoAtual,

        produtosRows,
        setProdutosRows,
        masterDetail,
        setMasterDetail,
        // totalizadores
        qtdRendUnit,
        setQtdRendUnit,
        custoSemImposto,
        setCustoSemImposto,
        valCustoReceita,
        setValCustoReceita,
        qtdTotReceita,
        setQtdTotReceita,
        qtdRendeKG,
        setQtdRendeKg,
        qtdTotProducao,
        setQtdTotProducao,
        valCustoProducao,
        setValCustoProducao,
        valCustoFinal,
        setValCustoFinal,

        formProducao: {
          reset,
          control,
          register,
          setValue,
          setError,
          getValues,
          setFocus,
          clearErrors,
          handleSubmit,
          formState,
          watch,
        },
      }}
    >
      {children}
    </CadastroProducaoContext.Provider>
  );
};
